import { Flex, Text } from "@chakra-ui/react";
import type { Stat } from "components/stats-grid";
import { generateSingularLabel } from "utils/generate-singular-label";

type PresentationStatProps = {
  stat: Stat;
  numberOfStats: number;
};
export function PresentationStat({
  stat,
  numberOfStats,
}: PresentationStatProps) {
  const widthClass =
    numberOfStats <= 2 ? "48%" : numberOfStats === 4 ? "48%" : "30%";

  return (
    <Flex
      direction={"column"}
      justify={"center"}
      align={"center"}
      gap={3}
      p={{ base: "20px", sm: "20px", lg: "50px" }}
      w={{ base: "100%", sm: "30%", md: widthClass }}
    >
      <Text
        fontSize={{ base: "48px", md: "72px" }}
        color={"gray.700"}
        fontWeight={800}
      >
        {stat.value}
      </Text>
      <Text
        fontSize={{ base: "xl", md: "2xl" }}
        color={"gray.700"}
        fontWeight={400}
        textAlign={"center"}
      >
        {generateSingularLabel(stat.label, stat.value as number)}
      </Text>
    </Flex>
  );
}
